module.exports = "https://web-assets.ifttt.com/packs/media/home/get-started-tree-2x-0e39a59d.png";